export const FILTER_ANY_VALUE = '__any__';

/**
 * Presentation tokens for the filter bars.
 *
 * Shared rather than copied per page so the shipments and excluded-products bars
 * cannot drift apart: both render the same "label above a 36px control, four to a
 * row, one apply button" shape, and that only stays true if the classes live in
 * one place.
 */
export const filterFieldLabelClasses = 'text-sm font-medium leading-none text-black';

export const filterSelectTriggerClasses =
  'h-9 rounded-[10px] border-[#e5e5e5] bg-white px-3 py-2 shadow-none focus:ring-0 data-[placeholder]:text-[#737373]';

export const filterInputClasses =
  'h-9 w-full min-w-0 rounded-l-[10px] border border-r-0 border-[#e5e5e5] bg-white px-3 text-sm focus-visible:outline-none placeholder:text-[#737373]';

export const filterSearchButtonClasses =
  'grid size-9 shrink-0 place-items-center rounded-r-[10px] border border-[#e5e5e5] bg-white hover:bg-accent';

/** The single apply button that closes every filter bar. */
export const filterSubmitButtonClasses =
  'flex h-9 shrink-0 items-center justify-center gap-2 rounded-[10px] border border-black bg-white px-4 text-sm font-medium leading-5 text-black hover:bg-accent';

/** Four fields per row on wide screens, two on tablets, one on phones. */
export const filterGridClasses = 'grid w-full gap-x-8 gap-y-4 md:grid-cols-2 xl:grid-cols-4';
